export const LOGO_MAKER_STORAGE_KEY = '_logoMakerState';
export const LOGO_MAKER_STORAGE_IMAGE = '_logoMakerImage';
export const LOGO_MAKER_STORAGE_DEFAULT_KEY = '_defaultLogoMakerState';
